module.exports = __webpack_public_path__ + "img/tmx-futar-logo-icon.18d19825.png";